(() => {
  if (window.vitalModalDismissReady) return;
  window.vitalModalDismissReady = true;
  let pressedDialog = null;
  const backdropDialog = event => {
    if (event.button !== 0) return null;
    const path = event.composedPath();
    const dialog = path.find(node => node instanceof HTMLDialogElement);
    if (!dialog || path[0] !== dialog || !dialog.open || !dialog.matches(':modal')) return null;
    const box = dialog.getBoundingClientRect();
    return event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom ? dialog : null;
  };
  document.addEventListener('pointerdown', event => {
    pressedDialog = event.isPrimary ? backdropDialog(event) : null;
  }, true);
  document.addEventListener('pointercancel', () => { pressedDialog = null; }, true);
  window.addEventListener('blur', () => { pressedDialog = null; });
  document.addEventListener('click', event => {
    const dialog = backdropDialog(event);
    const shouldClose = dialog && dialog === pressedDialog;
    pressedDialog = null;
    if (!shouldClose) return;
    if (typeof dialog.requestClose === 'function') dialog.requestClose();
    else if (dialog.dispatchEvent(new Event('cancel', {cancelable:true})) && dialog.open) dialog.close();
  }, true);
})();
